import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Box } from 'reflexbox';
import Loader from 'frontend/components/Loader';

const FallbackLoader = ({ height, delay }) => (
  <Flex align="center" justify="center" style={{ minHeight: height }}>
    <Box>
      <Loader delay={delay} />
    </Box>
  </Flex>
);

FallbackLoader.propTypes = {
  height: PropTypes.number,
  delay: PropTypes.number,
};
FallbackLoader.defaultProps = {
  height: 200,
  delay: 300,
};

export default FallbackLoader;
